import { ChevronRight } from "lucide-react";

import { useAwaitingToolsTableColumns } from "./AwaitingTableColumns";

import { CustomTable } from "@/components/reusables/data-table/CustomTable";
import EmptyData from "@/components/state-pages/EmptyData";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { PROJECT_CONSTANTS } from "@/constants/projects.constant";
import { IProjectAssignedTool } from "@/interfaces/tools.interface";
import { dateFormat } from "@/utils/helper-functions/date-time.helper";

interface AssignToolsAwaitingTableProps {
  data: IProjectAssignedTool[];
}

const AssignToolsAwaitingTable = ({
  data,
}: AssignToolsAwaitingTableProps): JSX.Element => {
  const { CONTENT_TEXT, EMPTY_MESSAGE } =
    PROJECT_CONSTANTS.ASSIGN_TOOLS_CONSTANTS;

  const columns = useAwaitingToolsTableColumns();

  return (
    <div className='mt-2'>
      <section className=' space-y-7'>
        {data?.length ? (
          data?.map((field, parentIndex) => {
            const selectedProductDetail = data?.find(
              (item) => item?.id === field?.id,
            );

            return (
              <Collapsible
                defaultOpen={parentIndex === 0 || parentIndex === 1}
                className='group'
                key={field.id}
              >
                <div className='flex justify-between items-center space-x-2 group-data-[state=closed]:border group-data-[state=closed]:rounded-md  group-data-[state=closed]:p-3 '>
                  <CollapsibleTrigger className='transition-transform'>
                    <div className='flex'>
                      <ChevronRight
                        className='min-w-5 min-h-5 mr-1 group-data-[state=open]:rotate-90 '
                        strokeWidth={2}
                      />
                      <h2 className='text-lg font-medium'>
                        {dateFormat(
                          selectedProductDetail?.createdAt,
                          "dd MMM yyyy | p",
                        )}
                      </h2>
                    </div>
                  </CollapsibleTrigger>
                </div>
                <CollapsibleContent>
                  <section className=' mt-5'>
                    <CustomTable
                      title={CONTENT_TEXT.AWAITING}
                      columns={columns}
                      data={selectedProductDetail?.productAssignments ?? []}
                      empty={{}}
                      hide={{
                        filters: true,
                        functions: true,
                      }}
                      filters={{
                        dateRange: true,
                      }}
                    />
                  </section>
                </CollapsibleContent>
              </Collapsible>
            );
          })
        ) : (
          <EmptyData title={EMPTY_MESSAGE.NO_AWAITING_TOOLS} />
        )}
      </section>
    </div>
  );
};

export default AssignToolsAwaitingTable;
